import PageHeader from '../../components/PageHeader';
import NewUserInfo from '../../Main/NewUserInfo';
import useStore from '../../Store/Store';
import VisitLists from './components/VisitLists';
import SideBar from '../../components/SideBar';
import { useTranslation } from 'react-i18next';
const DoctorVisit = () => {
  const { t } = useTranslation();
  return (
    <>
      <div style={{ display: 'flex', flexDirection: 'row' }}>
        <div>
          <SideBar />
        </div>

        <div style={{ flex: 1, display: 'flex', flexDirection: 'column' }}>
          <NewUserInfo isSideBar={false} />
          <div style={{ padding: '20px' }}>
            <PageHeader title={t('doctorVisit')} />
            <div
              style={{
                width: '100%',
                backgroundColor: '#fff',
                borderRadius: '12px',
                boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
                overflow: 'hidden',
                marginTop: '20px',
              }}
            >
              <div
                style={{
                  padding: '24px',
                  overflow: 'auto',
                }}
                className="hide-scroll"
              >
                <VisitLists />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default DoctorVisit;
